import React from "react";
import Keyboard from "react-simple-keyboard";
//import "react-simple-keyboard/build/css/index.css";
//import "../../css/modal1.css";
import "../../css/style.css";

export default class KeyBoard extends React.Component {
  state = {
    layoutName: "default",
    input: "",
  };
 
  onChange = input => {
    //console.log("Input com", this.props.input);
    //this.Keyboard.input(this.props.input);
    //this.setState({ input });
    //console.log("Input changed", input);
    this.props.onVirtualKeyBoardTyped(input);
    this.keyboard.clearInput();
  };

  onKeyPress = button => {
    //console.log("Button pressed", button);

     /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === "{shiftleft}" || button === "{shiftright}")
        this.handleShift();
    else
        if (button === "{capslock}")
            this.handleCapsLock();
        else
            if (this.state.layoutName === "shift" || this.state.layoutName === "capslockshift")
                this.handleShift();

  };

  handleShift = () => {
    const layoutName = this.state.layoutName;

    this.setState({
      layoutName: layoutName === "default" 
                    ? 
                    "shift" 
                    : 
                        layoutName ===  "capslock" 
                        ? 
                        "capslockshift" 
                        : 
                            layoutName === "capslockshift"
                            ?
                            "capslock"
                            :
                                layoutName === "shift"
                                ?
                                "default"
                                :
                                "shift"
    });

    //console.log("layoutName:",layoutName)
  };

  handleCapsLock = () => {
    const layoutName = this.state.layoutName;

    this.setState({
      layoutName: layoutName === "default" 
                    ? 
                    "capslock" 
                    : 
                        layoutName ===  "capslock" 
                        ? 
                        "default" 
                        : 
                            layoutName === "capslockshift"
                            ?
                            "shift"
                            :
                                layoutName === "shift"
                                ?
                                "capslock"
                                :
                                "default"
    });
    //console.log("layoutName:",layoutName)
  };


  render() {
    if(this.props.layout==="Phonetic")
    {
      return (
        <Keyboard
          baseClass={this.props.layout+'1'}
          keyboardRef={r => (this.keyboard = r)}
          //stateToIgnore={this.props.input}
          layoutName={this.state.layoutName}
          layout={{
            default: [
              "č δ γ ǰ š ž",
              "ā ē ī ō ū"
            ],
            shift: [
              "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
              "{tab} Q W E R T Y U I O P { } |",
              '{capslock} A S D F G H J K L : " {enter}',
              "{shiftleft} Z X C V B N M < > ? {shiftright}",
              ".com @ {space}"
            ],
            capslockshift: [
                "` 1 2 3 4 &spades; 5 7 8 9 0 - = {backspace}",
                "{tab} q w e r t y u i o p [ ] \\",
                "{capslock} a s d f g h j k l ; ' {enter}",
                "{shiftleft} z x c v b n m , . / {shiftright}",
                ".com @ {space}"
            ],
            capslock: [
              "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
              "{tab} Q W E R T Y U I O P { } |",
              '{capslock} A S D F G H J K L : " {enter}',
              "{shiftleft} Z X C V B N M < > ? {shiftright}",
              ".com @ {space}"
            ]
          }}
          onChange={this.onChange}
          onKeyPress={this.onKeyPress}
        />
      )
    }
    if (this.props.layout==="farsi")
    {
      return (
        <Keyboard
          baseClass={this.props.layout+'1'}
          keyboardRef={r => (this.keyboard = r)}
          layoutName={this.state.layoutName}
          layout={{
              default: [
                "خ ح چ ج ث ت پ ب ا آ",
                "ط ض ص ش س ژ ز ر ذ د",
                "ن م ل گ ک ق ف غ ع ظ",
                "ی ه و َ ِ ُ ً ٍ ٌ" 
              ],
              shift: [
              "× ! @ # $ % ^ & * ( ) _ + {backspace}",
              "{tab} ً ٌ ٍ ريال ، ؛ , ] [ \\ } { |",
              '{capslock} َ ُ ِ ّ ۀ آ ـ « » : " {enter}',
              "{shiftleft} ة ي ژ ؤ إ أ ء < > ؟ {shiftright}",
              ".com @ {space}"
              ],
              capslockshift: [
              "÷ 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
              "{tab} ض ص ث ق ف غ ع ه خ ح ج چ پ",
              "{capslock} ش س ی ب ل ا ت ن م ک گ {enter}",
              "{shiftleft} ظ ط ز ر ذ د ئ و . / {shiftright}",
              ".com @ {space}"
              ],
              capslock: [
              "× ! @ # $ % ^ & * ( ) _ + {backspace}",
              "{tab} ً ٌ ٍ ريال ، ؛ , ] [ \\ } { |",
              '{capslock} َ ُ ِ ّ ۀ آ ـ « » : " {enter}',
              "{shiftleft} ة ي ژ ؤ إ أ ء < > ؟ {shiftright}",
              ".com @ {space}"
              ]
          }}
          onChange={this.onChange}
          onKeyPress={this.onKeyPress}
        />
      )
    }
    
    if (this.props.layout==="english")
    {
      return (
        <Keyboard
          baseClass={this.props.layout+'1'}
          keyboardRef={r => (this.keyboard = r)}
          layoutName={this.state.layoutName}
          layout={{
              default: [
                "ʾ ḇ ḏ γ ẖ ḵ p̄ š y̠ ӯ ẕ",
                "Ḇ E̠ Ḏ G̱ Ḵ P̱ Y̱ Ẕ D͟R D͟Y Y͟R",
                "s͟n t͟y yy̠ y͟t y͟d͟y y͟d͟y͟y"
              ],
              shift: [
                "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
                "{tab} Q W E R T Y U I O P { } |",
                '{capslock} A S D F G H J K L : " {enter}',
                "{shiftleft} Z X C V B N M < > ? {shiftright}",
                ".com @ {space}"
              ],
              capslockshift: [
                  "` 1 2 3 4 &spades; 5 7 8 9 0 - = {backspace}",
                  "{tab} q w e r t y u i o p [ ] \\",
                  "{capslock} a s d f g h j k l ; ' {enter}",
                  "{shiftleft} z x c v b n m , . / {shiftright}",
                  ".com @ {space}"
              ],
              capslock: [
                "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
                "{tab} Q W E R T Y U I O P { } |",
                '{capslock} A S D F G H J K L : " {enter}',
                "{shiftleft} Z X C V B N M < > ? {shiftright}",
                ".com @ {space}"
              ]
            }}
          onChange={this.onChange}
          onKeyPress={this.onKeyPress}
        />
      )
    }

    if (this.props.layout==="Pahlavi")
    {
      return (
        <Keyboard
          baseClass={this.props.layout+'1'}
          keyboardRef={r => (this.keyboard = r)}
          layoutName={this.state.layoutName}
          layout={{
              default: [
                "غ ع ب ئ ث : ا گ ی ط",
                "ج # س ش م ئئ ض صق فل چ",
                "فقث ت خ ص ق ف قف فقف آ خل",
                "قفل ظ صل ؤ ة حل حت نل نت ه",
                "مل ضل غمت ^ % أ @ $"
              ],
              shift: [
              "× ! @ # $ % ^ & * ( ) _ + {backspace}",
              "{tab} ً ٌ ٍ ريال ، ؛ , ] [ \\ } { |",
              '{capslock} َ ُ ِ ّ ۀ آ ـ « » : " {enter}',
              "{shiftleft} ة ي ژ ؤ إ أ ء < > ؟ {shiftright}",
              ".com @ {space}"
              ],
              capslockshift: [
              "÷ 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
              "{tab} ض ص ث ق ف غ ع ه خ ح ج چ پ",
              "{capslock} ش س ی ب ل ا ت ن م ک گ {enter}",
              "{shiftleft} ظ ط ز ر ذ د ئ و . / {shiftright}",
              ".com @ {space}"
              ],
              capslock: [
              "× ! @ # $ % ^ & * ( ) _ + {backspace}",
              "{tab} ً ٌ ٍ ريال ، ؛ , ] [ \\ } { |",
              '{capslock} َ ُ ِ ّ ۀ آ ـ « » : " {enter}',
              "{shiftleft} ة ي ژ ؤ إ أ ء < > ؟ {shiftright}",
              ".com @ {space}"
              ]
          }}
          onChange={this.onChange}
          onKeyPress={this.onKeyPress}
        />
      )
    }
  }
}
